var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9123 4.57095C2.58819 4.20587 2.1541 4.00386 1.70353 4.00843C1.25295 4.01299 0.821943 4.22377 0.503326 4.59536C0.18471 4.96695 0.00398034 5.46963 6.49621e-05 5.99511C-0.00385041 6.5206 0.169362 7.02686 0.482393 7.40485L3.91932 11.4132C4.24158 11.7889 4.67859 12 5.13427 12C5.58994 12 6.02696 11.7889 6.34922 11.4132L13.2231 3.3965C13.5361 3.01851 13.7093 2.51225 13.7054 1.98676C13.7015 1.46127 13.5208 0.958601 13.2021 0.58701C12.8835 0.21542 12.4525 0.00464212 12.0019 7.57628e-05C11.5514 -0.00449059 11.1173 0.19752 10.7932 0.562597L5.13427 7.16235L2.9123 4.57095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipWhite);
export default __webpack_public_path__ + "static/media/tip_white.dac48dc62529147ad2d8df4b46e474b2.svg";
export { ForwardRef as ReactComponent };